// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const addSubscriberMailchimp = async (payload) => {
  return await fetch(
    "https://us-central1-zefi-cms.cloudfunctions.net/addSubscriber",
    {
      method: "POST",
      body: payload,
      mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  )
    .then((res) => console.log("response: ", res))
    .catch((error) => {
      console.log("error:", error);
    });
};

export { addSubscriberMailchimp };
